module.exports = __webpack_public_path__ + "p2_img1.jpg?6c08a976e11e31ff1515df8fd21f9967";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p2/p2_img1.jpg
// module id = 100
// module chunks = 0